export type AnalystExhibitAppearance = "card" | "inline";

// A thread exhibit sits in the text flow: no fill or padding at rest, only a
// border on hover. The negative margin keeps the plot aligned with the text
// while the hover card reaches past the column.
export function analystExhibitFrameClassName(appearance: AnalystExhibitAppearance = "card"): string {
  if (appearance === "inline") {
    return "-mx-4 rounded-xl border border-transparent px-4 py-3 transition-colors hover:border-border";
  }
  return "rounded-xl border border-border bg-card p-4";
}
